<template>
    <Fieldset :title="$t('labels.basic_information')">
        <div class="row">
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.name')" :required="true">
                    <Input v-model="inventoryStatus.name" type="string" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.type')" :required="true">
                    <Select v-model="inventoryStatus.type" :options="inventoryStatusTypesOptions" :disabled="inventoryStatus.uuid != null" optionKey="key" optionValue="value" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.color')" :required="true">
                    <Input v-model="inventoryStatus.color" type="color" />
                </FormGroup>
            </div>
            <div class="col-lg-3">
                <FormGroup :label="$t('labels.queue')">
                    <Input v-model="inventoryStatus.order" type="string" />
                </FormGroup>
            </div>
        </div>
    </Fieldset>
</template>
<script>
import Input from '../../../../../components/new/form/Input.vue'
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue'
import Fieldset from '../../../../../components/new/AppFieldset.vue'
import Select from '../../../../../components/new/form/select/Select.vue'
import { InventoryStatusTypeEnum } from '../../../../enums/InventoryStatusTypeEnum'
export default {
    name: "InventoryStatusFieldsetGroup",
    components: {
        Input, FormGroup, Fieldset, Select
    },
    props: {
        inventoryStatus: {
            type: Object,
            required: true
        }
    },
    computed: {
        inventoryStatusTypesOptions() {
            return Object.values(InventoryStatusTypeEnum).map((value) => {
                return {
                    key: value,
                    value: this.$t(`enum.inventory-status.type.${value}`)
                }
            })
        }
    }
}
</script>
